module.exports = __webpack_public_path__ + "img/astral_8.61e135b6.svg";